import { Component, OnInit } from "@angular/core";
import { Http } from "@angular/http";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { RedirecionamentoMatriculaService } from "../_shared/redirecionamento-matricula/redirecionamento-matricula.service";
import { ProcessoService } from "./../_shared/processo/processo.service";
import { SessionService } from "./../_shared/session/session.service";
import { ContatoService } from "../_shared/contato/contato.service";
import { Contato } from "../_shared/contato/contato";
@Component({
  selector: "app-mensagem-final-matricula-online",
  templateUrl: "./mensagem-final-matricula-online.component.html",
  styleUrls: ["./mensagem-final-matricula-online.component.css"],
})
export class MensagemFinalMatriculaOnlineComponent implements OnInit {
  protected privateKeyNonce: string = "token_univali";
  protected contato: Contato;

  constructor(
    private http: Http,
    protected route: ActivatedRoute,
    private router: Router,
    private SessionService: SessionService,
    private ProcessoService: ProcessoService,
    private RedirecionamentoMatriculaService: RedirecionamentoMatriculaService,
    private contatoService: ContatoService
  ) {}

  aparecerMatricula() {
    return this.SessionService.getValor("matriculado") !== "true";
  }

  ngOnInit() {

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      window.scrollTo(0, 0);
    });

    this.contatoService.getContatoInfo().subscribe(
      (contato: Contato) => {
        this.contato = contato;
      },
      (error) => {
        console.error('Erro ao obter informações de contato:', error);
      }
    );

	  this.SessionService.configurarLimpezaSessaoAoRecarregarOuVoltarPagina();

    this.ProcessoService.fichaInscricao().subscribe(
      (ficha) => {
        if (ficha) {
          this.ProcessoService.enviaEmail().subscribe(
            (result) => {
              return;
            },
            (err) => {
              this.SessionService.clear();
              return err;
            }
          );
        }
      },
      (err) => {
        this.SessionService.clear();
        return err;
      }
    );
  }

  async proximo() {
    this.ProcessoService.enviaLogMatricula().subscribe(
      (result) => {
        this.RedirecionamentoMatriculaService.redirecionar();
        return;
      },
      (err) => {
        this.SessionService.clear();
        return err;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/mensagem-final-matricula-online/mensagem-final-matricula-online.component.ts